import { useIsThrottleActive } from "../../hooks/useIsThrottleActive";

/**
 * Whether the Apollo-migrated MarketCard is switched on. It ships active in every environment; the
 * throttle exists so the migrated card can be turned off in production without a revert.
 *
 * Read here rather than in `PebbleContent` directly so the two render paths can be tested by mocking one
 * hook, instead of driving a whole Redux state through the `useSelector` the card wrapper also uses.
 */
export const useMarketCardApolloThrottle = (): boolean => useIsThrottleActive("MARKET_CARD_APOLLO");
